<template>
  <div id="lineThree" class="chart"></div>
</template>
<script>
import { statisticsApi } from "@/api"
export default {
  name: "lineThree",
  data() {
    return {
      myChart: null,
      chartData: []
    }
  },
  created() {
    this.getSevenDayMoveData()
  },
  methods: {
    resize() {
      this.myChart&&this.myChart.resize()
    },
    getSevenDayMoveData() {
      statisticsApi.getSevenDayMoveData().then(res => {
        this.chartData = res
        this.drawChars()
      })
    },
    drawChars() {
      var chartDom = document.getElementById("lineThree")
      this.myChart = this.$echarts.init(chartDom)
      var option

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        xAxis: {
          type: "category",
          name: "日",
          boundaryGap: false,
          data: this.chartData.map(item => item.name),
          axisLabel: {
            show: true,
            color: "#333",
            fontSize: 12
          }
        },
        yAxis: {
          type: "value",
          name: "件",
          axisLabel: {
            show: true,
            color: "#333",
            fontSize: 12
          }
        },
        grid: {
          left: "3%",
          right: "10%",
          bottom: "3%",
          top: "10%",
          containLabel: true
        },
        series: [
          {
            data: this.chartData.map(item => item.value),
            type: "line",
            itemStyle: {
              color: "rgb(197, 139, 234)" // 设置折线颜色
            },
            lineStyle: {
              width: 4 // 折线的宽度
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(197, 139, 234, 1)" }, // 渐变起始颜色
                { offset: 1, color: "rgba(250, 244, 253, 0.3)" } // 渐变结束颜色
              ])
            },
            emphasis: {
              lineStyle: {
                width: 4, // 增加鼠标悬浮时折线的宽度
                color: "rgb(197, 139, 234)" // 保持鼠标悬浮时折线的颜色
              }
            }
          }
        ]
      }

      option && this.myChart.setOption(option)
    }
  }
}
</script>
<style lang="scss" scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
